import { cn } from '@rocco/utils/cn';
import { RoccoLink } from '@rocco/components/link';

export interface CategoryPill {
    label: string;
    /** When set the pill renders as a link; otherwise a static tag. */
    to?: string;
}

export interface CategoryPillsProps {
    /** Heading above the pill row, e.g. "Popular categories:". */
    label?: string;
    items: CategoryPill[];
    className?: string;
}

const pillClass =
    'inline-flex items-center justify-center whitespace-nowrap rounded-full border border-current uppercase text-current transition-opacity hover:opacity-70 max-md:px-[2.13vw] max-md:text-[1.83vw] max-md:leading-[4.57vw] md:px-[0.729vw] md:text-[0.625vw] md:leading-[1.5625vw]';

/**
 * "Popular categories:" heading plus a wrapping row of outline pill tags
 * (Neue Haas Roman 12px uppercase on the 1920 frame). Pills inherit the
 * section's text colour via `border-current`/`text-current` so the component
 * reads on both light and dark sections.
 */
export const CategoryPills = ({
    label,
    items,
    className,
}: CategoryPillsProps) => (
    <div
        className={cn(
            'flex flex-col max-md:gap-[2.6vw] md:gap-[1.09vw]',
            className,
        )}
    >
        {label && (
            <span className="font-sans leading-none opacity-60 max-md:text-[2.6vw] md:text-[1.04vw]">
                {label}
            </span>
        )}
        <div className="flex flex-wrap items-center max-md:gap-x-[0.31vw] max-md:gap-y-[0.78vw] md:gap-[0.31vw]">
            {items.map((item) =>
                item.to ? (
                    <RoccoLink
                        key={item.label}
                        to={item.to}
                        className={pillClass}
                    >
                        {item.label}
                    </RoccoLink>
                ) : (
                    <span key={item.label} className={pillClass}>
                        {item.label}
                    </span>
                ),
            )}
        </div>
    </div>
);
